import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

function Chevron({ direction, className }) {
  return (
    <span
      aria-hidden="true"
      className={classNames(styles.chevron, styles[direction], className)}
    />
  );
}

Chevron.propTypes = {
  direction: PropTypes.oneOf(['bottom', 'top', 'left', 'right']).isRequired,
  className: PropTypes.string,
};

Chevron.defaultProps = {
  className: null,
};

export default Chevron;



// WEBPACK FOOTER //
// ./src/app/components/Chevron/index.js